import { styled } from '@mui/material';
import { ReactNode } from 'react';

import { Sidebar } from '../Sidebar';

const Layout = styled('div')({
  display: 'flex',
  height: '100vh',
  position: 'relative',
});

export type TwoSidedLayoutProps = {
  sidebar: ReactNode;
  children: ReactNode;
};

export const TwoSidedLayout = ({ sidebar, children }: TwoSidedLayoutProps) => {
  return (
    <Layout>
      <Sidebar>{sidebar}</Sidebar>
      {children}
    </Layout>
  );
};
